module.exports = __webpack_public_path__ + "static/media/handshake-orange.fa4b7a1a.svg";